import { MapSearchFilterBy } from '~/map/filter/mapSearchFilterBy.enum';
import { MapKeyType } from '~/sidebar/sidebarApps/rightSidebar/masterKey/masterKey.types';
import { restoreThemeType } from '~/store/theme/theme.helpers';
import { type MapSettingsPublicMapSettingsAction } from './mapSettingsPublicMapSettings.action';
import { publicMapSettingsSetMapKeyType } from './mapSettingsPublicMapSettings.actionCreators';
import {
  MAP_SETTINGS_PUBLIC_MAP_SETTINGS_SET_ALLOWED_EXPORT_DATA_TOOLS, MAP_SETTINGS_PUBLIC_MAP_SETTINGS_SET_THEME,
  MAP_SETTINGS_PUBLIC_MAP_SETTINGS_SET_ZOOM_RESTRICT_LEVELS, MAP_SETTINGS_PUBLIC_MAP_SETTINGS_UPDATE,
  MAP_SETTINGS_PUBLIC_MAP_SETTINGS_UPDATE_DROPDOWNS, MAP_SETTINGS_PUBLIC_MAP_SETTINGS_UPDATE_SEARCH_FILTER_OPTION,
} from './mapSettingsPublicMapSettings.actionTypes';
import { type MapSettingsPublicMapSettingsState } from './mapSettingsPublicMapSettings.state';

export const publicMapSettingsInitialState: MapSettingsPublicMapSettingsState = {
  allowedExportDataTools: [],
  allowSatelliteView: true,
  allowStreetView: true,
  boundaryTool: false,
  displayLegendOnly: false,
  displaySearchBox: true,
  displayTitleAndDescription: true,
  distanceCalculator: true,
  filterMenusOpen: false,
  filterTool: false,
  groupingTool: false,
  heatMappingTool: false,
  lassoTool: false,
  legendReplacesGrouping: false,
  locationFinder: false,
  locationFinderStartsOpen: false,
  mapKey: false,
  mapKeyOpen: false,
  mapImageExport: false,
  mapToolsMenuOpen: false,
  defaultOpenMapToolPresentationalMap: undefined,
  defaultOpenMapKey: MapKeyType.MasterKey,
  mapZoom: true,
  markersVisibilityButton: true,
  radiusProximity: false,
  restrictMapPanning: false,
  routingDirections: true,
  searchBarAlwaysVisible: false,
  showSearchFilter: false,
  searchBarFilterDefaultOption: MapSearchFilterBy.OnlyUserData,
  showMyLocation: true,
  showMyLocationDefault: false,
  theme: restoreThemeType().type,
  zoomRestrictLevels: [undefined, undefined],
};

export const getPublicMapSettingsInitialState = () => ({
  ...publicMapSettingsInitialState,
  theme: restoreThemeType().type,
});

export const mapSettingsPublicMapSettingsReducer = (
  state: MapSettingsPublicMapSettingsState = getPublicMapSettingsInitialState(),
  action: MapSettingsPublicMapSettingsAction
): MapSettingsPublicMapSettingsState => {

  if (publicMapSettingsSetMapKeyType.match(action)) {
    return {
      ...state,
      defaultOpenMapKey: action.payload.mapKeyType,
    };
  }

  switch (action.type) {
    case MAP_SETTINGS_PUBLIC_MAP_SETTINGS_UPDATE:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };

    case MAP_SETTINGS_PUBLIC_MAP_SETTINGS_SET_ZOOM_RESTRICT_LEVELS: {
      return {
        ...state,
        zoomRestrictLevels: action.payload.zoomLevels,
      };
    }

    case MAP_SETTINGS_PUBLIC_MAP_SETTINGS_UPDATE_DROPDOWNS: {
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    }

    case MAP_SETTINGS_PUBLIC_MAP_SETTINGS_UPDATE_SEARCH_FILTER_OPTION: {
      return {
        ...state,
        searchBarFilterDefaultOption: action.payload.searchBarFilter,
      };
    }

    case MAP_SETTINGS_PUBLIC_MAP_SETTINGS_SET_ALLOWED_EXPORT_DATA_TOOLS: {
      return {
        ...state,
        allowedExportDataTools: Array.from(action.payload.allowedTools),
      };
    }

    case MAP_SETTINGS_PUBLIC_MAP_SETTINGS_SET_THEME: {
      return {
        ...state,
        theme: action.payload.value,
      };
    }

    default:
      return state;
  }
};
